import { ReduxStore } from '../store';

const subscriptionSelector = {
  getLoading: (state: ReduxStore) => state.subscription.status,
  getSubscription: (state: ReduxStore) => state.subscription.subscription,
  getSubscriptionPreview: (state: ReduxStore) => state.subscription.subscriptionPreview,
  wasCanceled: (state: ReduxStore) => state.subscription.canceled,
  wasUpdated: (state: ReduxStore) => state.subscription.updated,
};

export default subscriptionSelector;
